<template>
<div>
  <h1>Let’s get some basic details about you.</h1>

  <baseInputWithLabel
    :class="{ 'not-valid-data': (() => ($v.form.weight.$dirty && $v.form.weight.$invalid ? true : undefined))() }"
    label="Weight (lbs)"
    inputType="text"
    v-model="form.weight"
    :required="true"
    @baseInputChanged="
      ($event) => {
        setMacrosWeight($event.target.value);
        form.weight = $event.target.value;
        $v.form.weight.$touch();
      }
    "
  />

  <baseSelectWithLabel
    label="Height"
    inputType="text"
    :value="form.height"
    :options="heightOptions"
    @baseSelectChanged="
      ($event) => {
        setMacrosHeight($event.target.value);
        form.height = $event.target.value;
        $v.form.height.$touch();
      }
    "
  />

  <baseInputWithLabel
    :class="{ 'not-valid-data': (() => ($v.form.age.$dirty && $v.form.age.$invalid ? true : undefined))() }"
    label="Age (years)"
    inputType="text"
    v-model="form.age"
    :required="true"
    @baseInputChanged="
      ($event) => {
        setMacrosAge($event.target.value);
        form.age = $event.target.value;
        $v.form.age.$touch();
      }
    "
  />

  <div class="button-container">
    <label class="gender-label">Gender</label>
    <baseRoundedRadioButton
      class="activity-selector"
      v-for="(option, index) in genderOptions"
      :key="'type-' + option.title"
      :title="option.title"
      :index="index"
      v-model="form.genderSelectionIndex"
      :isChecked="option.value === form.genderSelectionIndex"
      :is-multiple="false"
      :darkBg="false"
      @roundedRadioCheckUncheck="
        ($event) => {
          form.genderSelectionIndex = genderOptions[$event.index].value;
          setMacrosGenderSelectionIndex(genderOptions[$event.index].value);
        }
      "
    />
  </div>
</div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, email, integer, numeric, minValue } from 'vuelidate/lib/validators';
import baseInputWithLabel from '../_base-input-with-label';
import baseSelectWithLabel from '../_base-select-with-label';
import baseRoundedRadioButton from '../_base-rounded-radio-button';
import { macroCalculatorComputed, macroCalculatorMethods } from '@state/helpers';
import store from '@state/store';

export default {
  props: ['clickedNext', 'currentStep'],
  mixins: [validationMixin],
  components: {
    baseInputWithLabel,
    baseSelectWithLabel,
    baseRoundedRadioButton,
  },
  data() {
    return {
      form: {
        weight: null, //pounds by default
        height: 69, //inches by default
        age: null,
        genderSelectionIndex: null,
      },
    };
  },
  validations: {
    form: {
      weight: {
        required,
        validateWeight(value) {
          if (!value || (value && parseFloat(value) < 1)) {
            return false;
          } else return true;
        },
      },
      height: {
        required,
        numeric,
      },
      age: {
        required,
        integer,
      },
      genderSelectionIndex: {
        required,
      },
    },
  },
  watch: {
    $v: {
      handler: function(val) {
        if (!val.$invalid) {
          this.$emit('can-continue', { value: true });
        } else {
          this.$emit('can-continue', { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.$v.form.$touch();
      }
    },
    currentStep() {
      // If form is valid when user navigates back and forth
      // between steps let's allow them to continue
      if (!this.$v.form.$invalid) {
        this.$emit('can-continue', { value: true });
      }
    },
  },
  mounted() {
    if (!this.$v.$invalid) {
      this.$emit('can-continue', { value: true });
    } else {
      this.$emit('can-continue', { value: false });
    }
  },
  computed: {
    ...macroCalculatorComputed,
  },
  methods: {
    ...macroCalculatorMethods,
  },
};
</script>

<style scoped>
.gender-label {
  display: block;
  font-size: 1.7rem;
  margin-bottom: 1rem;
}
</style>
